<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="length-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Durée du mandat</p>
            <p class="no-margin dark-gray text-sm">Durée des mandats des élus CSE</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;" id="length-grid"
    class="p-20">
    <div>
      <p class="dark-gray no-margin">Années</p>
      <p class="dark-blue bold">{{termLength.duration[0]}} an(s)</p>
    </div>

    <div>
      <p class="dark-gray no-margin">Mois</p>
      <p class="dark-blue bold">{{termLength.duration[1]}} mois</p>
    </div>
  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>

  </div>
</div>